module.exports = __webpack_public_path__ + "static/media/android.cf39c557.svg";